/**
 * Keys a page adds while it is open (the Inbox's j, k, a, s, r, d), listed in the ? sheet under the
 * page's name. One page at a time: the one mounted last wins and clears on unmount.
 */
import { useEffect } from 'react';
import { create } from 'zustand';
import type { ShortcutHelp } from './shortcuts.ts';

interface PageShortcuts {
  page: { title: string; items: readonly ShortcutHelp[] } | null;
  set: (page: PageShortcuts['page']) => void;
}

export const usePageShortcuts = create<PageShortcuts>((set) => ({ page: null, set: (page) => set({ page }) }));

/** List this page's keys in the ? sheet while it is mounted. */
export function usePageShortcutHelp(title: string, items: readonly ShortcutHelp[]): void {
  useEffect(() => {
    const page = { title, items };
    usePageShortcuts.getState().set(page);
    return () => {
      if (usePageShortcuts.getState().page === page) usePageShortcuts.getState().set(null);
    };
  }, [title, items]);
}
